import { withAuthenticationRequired } from '@auth0/auth0-react';
import CreateTemplate from '@components/obsolete/CreateTemplate/CreateTemplate.tsx';

const PageTemplateEdit = () => {
  return <CreateTemplate />;
};

export default withAuthenticationRequired(PageTemplateEdit);
